export default "__VITE_ASSET__C07nI9Yq__ 480w, __VITE_ASSET__D_UKxwm5__ 768w, __VITE_ASSET__BDjqu4qR__ 1200w, __VITE_ASSET__BxM1cXWq__ 1824w";